<template>
	<div>
		<!-- <el-carousel :interval="4000" type="card" height="200px">
			<el-carousel-item v-for="(item,index) in list" :key="index" @click="goDetail(item)">
				<div class="swiper-slide">
					<img :src="item.url" />
					<div class="swiper-slide-wz " :class="activeIndex==index?' ':''"
						style="animation-duration: 1s;">
						<div class="swiper-slide-dw-name">
							<div v-for="(itema,indexa) in item.other.bigTitle" :key="indexa">
								{{itema.title}}
							</div>
						</div>
						<div class="swiper-slide-dw-cen">
							<div v-for="(itema,indexa) in item.other.smallTitle" :key="indexa">
								{{itema.title}}
							</div>
						</div>
					</div>
				</div>
			</el-carousel-item>
		</el-carousel> -->
		<!-- 核心swiper -->
		<div class="swiper-hexinOne">
			<div class="swiper-wrapper" ref="video">
				<div class="swiper-slide" v-for="(item,index) in list" :key="index" @click="goDetail(item)">
					<!-- {{activeIndex}}&&{{index}} -->
					<!-- v-show="activeIndex==index&&item.video" -->
					<!-- <video :src="item.url"  muted loop webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline="true" controls preload="auto"  @click.stop="goPlay" :poster="item.url+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video> -->
					<video :src="item.url" v-if="headerShow"  muted loop   :poster="item.url+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
					<!-- @click.stop="goPlay" -->
					<video :src="item.url" v-else muted loop webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline="true" controls preload="auto"  :poster="item.url+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
					<img :src="item.cover" />
					<!-- <div class="swiper-slide-wz " :class="activeIndex==index?'animate__fadeInUp':'animate__fadeOutUp'"
						>
						<div class="swiper-slide-dw-name " >
							<div v-for="(itema,indexa) in item.other.bigTitle" :key="indexa">
								{{itema.title}}
							</div>
						</div>
						:class="activeIndex==index?'animate__fadeInUp':'animate__fadeOutUp'"
						<div class="swiper-slide-dw-cen " >
							<div v-for="(itema,indexa) in item.other.smallTitle" :key="indexa">
								{{itema.title}}
							</div>
						</div>
					</div> -->
				</div>
			</div>
			<div class="swiper-hexin-prev" :style="{
				left:`calc(${bj}px + 30px) `
			}" @click="prev()">
				<img src="@/assets/index/hxz.png" />
			</div>
			<div class="swiper-hexin-next" :style="{
				right:`calc(${bj}px + 30px) `
			}" @click="next()">
				<img src="@/assets/index/hxy.png" />
			</div>
			<!-- width: `calc(100% - ${bj}px - ${bj}px - 60px) `, -->
			<div class="swiper-hexin-scrollbar" :style="{
				left:`calc(${bj}px + 30px) `
			}">
				<div class="swiper-scrollbar-drag"></div>
			</div>
			<div class="swiper-hexin-pagination">
				<div class="swiper-pagination-bullet" :class="activeIndex==index?'swiper-pagination-bullet-active':'' " v-for="(item,index) in list" :key="index">
					<div></div>
				</div>
			</div>
			<div class="wxBox" >
				<div class="wxBoxTwo">
					<!-- [activeIndexTwo==index?'xz':'',activeIndexTwo<index?'wxzTwo':'',activeIndexTwo>index?'wxz':''] -->
					<!-- :class="activeIndexTwo==index?'xz':''" -->
				<div class="swiper-slide-wz" ref="wxSlide" v-for="(item,index) in list" :key="index" >
					<div class="swiper-slide-dw-name " >
						<div v-for="(itema,indexa) in item.other.bigTitle" :key="indexa">
							{{itema.title}}
						</div>
					</div>
					<div class="swiper-slide-dw-cen " >
						<div v-for="(itema,indexa) in item.other.smallTitle" :key="indexa" :style="{
								height:itema.title?'':'20px',
								letterSpacing: '0.1em'
							}">
							{{itema.title}}
						</div>
					</div>
				</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		data() {
			return {
				mySwiper: '',
				activeIndex: 0,
				bj:'',
				activeIndexTwo:0,
				list:[]
			}
		},
		watch:{
			activeIndexTwo(){
				let t=this;
				this.setClass()
			},
			activeIndex(){
				let t=this;
				if(t.activeIndex!=t.activeIndexTwo){
					t.activeIndexTwo=t.activeIndex
				}
				console.log(this.activeIndex)
			},
			bj(){
				let t = this;
				this.$nextTick(function(){
					
					// loopAdditionalSlides:1,
					this.mySwiper = new this.$swiper('.swiper-hexinOne', {
						// 方向
						direction: 'horizontal',
						slidesPerView: 'auto',
						spaceBetween: 20,
						slidesOffsetBefore: this.bj,
						slidesOffsetAfter:  this.bj,
						speed: 1000,
						loop:true,
						// 自动播放
						autoplay: false,
						pagination:{
							el: ".swiper-hexin-pagination",
							type:'custom',
							clickable: true,
						},
						scrollbar: {
							el: ".swiper-hexin-scrollbar",
							draggable: true,
						},
						navigation: {
							prevEl: ".swiper-hexin-prev",
							nextEl: ".swiper-hexin-next",
						},
						initialSlide:0,
						on: {
							slideChangeTransitionStart: function(){
							      // alert(this.activeIndex);
								  t.activeIndexTwo = this.realIndex;
							    },
							slideChangeTransitionEnd(e) {
								// console.log(this.realIndex,'aa',t.mySwiper.activeIndex,this.activeIndex)
								t.activeIndex = this.realIndex;
								
								// t.activeIndex=t.mySwiper.activeIndex;
								t.$refs['video'].querySelectorAll('.swiper-slide video').forEach(item=>{
									item.pause()
									item.style="display:none;"
								})
								t.$refs['video'].querySelectorAll('.swiper-slide img').forEach(item=>{
									item.style="display:block;"
								})
								t.$nextTick(function(){
									
									// console.log(t.$refs['video'].querySelectorAll('.swiper-slide video')[t.mySwiper.activeIndex])
									t.$refs['video'].querySelectorAll('.swiper-slide img')[t.mySwiper.activeIndex].style="display:none;"
									t.$refs['video'].querySelectorAll('.swiper-slide video')[t.mySwiper.activeIndex].style="display:block;"
									t.$refs['video'].querySelectorAll('.swiper-slide video')[t.mySwiper.activeIndex].play()
									// t.$refs['video'][t.activeIndex].query.play();
								})
								// console.log(t.activeIndex)
								t.$forceUpdate()
							},
							init(e) {
								
							},
						},
					});
					setTimeout(function(){
						// t.mySwiper.slideNext()
					},300)
				})
			}
		},
		computed:{
			wzFun(e){
				// activeIndex==index?'xz':activeIndex<index?'wxz':'wxzTwo'
				console.log(e)
			}
		},
		mounted() {
			this.getWidth();
			let t=this
			
		},
		methods: {
			setList(e){
				let t=this;
				console.log(e)
				this.list=e;
				this.$nextTick(function(){
					this.setClass()
					t.$refs['video'].querySelectorAll('.swiper-slide video')[t.activeIndexTwo].play()
				})
			},
			getWidth(){
				console.log(document.body.clientWidth,window.screen.availWidth)
				let width=''
				// if(document.body.clientWidth>window.screen.availWidth){
				// 	 width=document.body.clientWidth - 1200;
				// }else{
				// 	 width=window.screen.availWidth - 1200;
				// }
				if(document.body.clientWidth>1200){
					 width=document.body.clientWidth - 1200;
				}else{
					 width=0;
				}
				this.$nextTick(function(){
					this.bj=width/2;
					console.log(this.bj,"边距")
				})
			},
			goDetail(e) {
				console.log(e)
				location.href=e.jump_url
				// return
				// this.$router.push({
				// 	path: '/innovationDetail',
				// 	name: 'innovationDetail',
				// 	query: {
				// 		id: e.id,
				// 		infoId: e.info_id
				// 	}
				// })
			},
			next(){
				console.log("right")
				let t=this;
				if(t.activeIndexTwo==t.list.length-1){
					t.activeIndexTwo = 0;
				}else{
					t.activeIndexTwo++;
				}
				// this.mySwiper.slideNext()
			},
			prev(){
				let t=this;
				if(t.activeIndexTwo==0){
					t.activeIndexTwo = t.list.length-1;
				}else{
					t.activeIndexTwo--;
				}
				console.log("left")
				// this.mySwiper.slidePrev()
			},
			setClass(){
				let t=this;
				// 拿到所有的文字dom
				let elmt=t.$refs['wxSlide'];
				// 当前选中上一个
				let prev=t.activeIndexTwo-1;
				// 当前选中下一个
				let next=t.activeIndexTwo+1;
				// 所有文字的长度
				let all=t.list.length-1;
				t.$refs['wxSlide'].map(v=>{
					v.classList.remove('wxzTwo')
					v.classList.remove('wxz')
					v.classList.remove('xz')
				})
				this.$nextTick(function(){
					
					// 首先移除当前 选中的样式 并且添加向上的样式
					if(prev>= 0){
						elmt[prev].classList.add('wxz')
					}else{
						elmt[all].classList.add('wxz')
					}
					// 给当前样式移除未选择的类
					elmt[t.activeIndexTwo].classList.add('xz')
					// 当前选中位最后一个 给第一个设置样式
					if(next>t.list.length-1){
						elmt[0].classList.add('wxzTwo')
					}else{
						elmt[next].classList.add('wxzTwo')
					}
					// 当前选中等于0时
					if(t.activeIndexTwo==0){
						elmt[all].class='wxz'
					}else if(t.activeIndexTwo==all){
						elmt[0].class='wxz'
					}
				})
				
				
			},
			goPlay(){
				let t=this;
				t.$refs['video' + t.activeIndex][0].play();
				t.$bus.$emit('overLoad')
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.swiper-hexinOne {
		overflow: hidden;
		position: relative;

		.swiper-hexin-prev {
			position: absolute;
			top: 50%;
			left: 250px;
			z-index: 99;
			width: 48px;
			height: 48px;
			cursor: pointer;
			img {
				width: 14px;
				height: 24px;
			}

			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 100%;
			transform: translateY(-50%);
			transition: all 0.3s ease;
		}

		.swiper-hexin-prev:hover {
			background-color: rgba(0, 0, 0, .3);
			// background-color: rgba(255,255,255,.3);
		}

		.swiper-hexin-next:hover {
			background-color: rgba(0, 0, 0, .3);
			// background-color: rgba(255,255,255,.3);

		}

		.swiper-hexin-next {
			transform: translateY(-50%);
			position: absolute;
			top: 50%;
			right: 250px;
			z-index: 99;
			width: 48px;
			height: 48px;
			border-radius: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: all 0.3s ease;
			cursor: pointer;
			img {
				width: 14px;
				height: 24px;
			}
		}

		.swiper-hexin-scrollbar {
			display: none;
			position: absolute;
			bottom: 20px;
			z-index: 999;
			left: 250px;
			background-color: #666;
			width: 300px;
			margin: 0 auto;
			height: 6px;
			transform: translateX(-50%);
			left: 50% !important;
		}

		// /* 修改滚动条滑块的颜色 */
		.swiper-scrollbar-drag {
			background-color: #fff;
			// transition: all 0.3s ease-in-out;
			// position: absolute;
			// left: 0;
		}
		.swiper-hexin-pagination{
			position: absolute;
			bottom: 48px;
			z-index: 999;
			// background-color: #666;
			margin: 0 auto;
			height: 24px;
			transform: translateX(-50%);
			left: 50% !important;
			display: flex;
			align-items: center;
			justify-content: center;
			.swiper-pagination-bullet-active{
				background:transparent;
				>div{
					background: #fff !important;
				}
			}
			.swiper-pagination-bullet:not(:first-child){
				margin-left: 4px;
			}
			.swiper-pagination-bullet{
				background:transparent;
				height: 24px;
				width: 16px;
				display: flex;
				align-items: center;
				justify-content: center;
				opacity:1;
				>div{
					cursor: pointer;
					width: 16px;
					height: 2px;
					background-color: rgba(255, 255, 255, .3);
					border-radius: 60px;
					position: relative;
				}
				
			}
		}
	}

	.swiper-slide {
		position: relative;
		cursor: pointer;
		max-width: 1200px !important;
		img {
			width: 100%;
			height: 600px;
			object-fit: cover;
		}

		video {
			width: 100%;
			height: 600px;
			object-fit: cover;
		}

		

	}
	.wxBox{
		position: absolute;
		top: 80px;
		left: 0;
		z-index: 20;
		width: 100%;
		pointer-events: none;
		.wxBoxTwo{
			width: 1200px;
			margin: 0 auto;
			position: relative;
		}
		.swiper-slide-wz {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			text-align: center;
			// font-size: 44px;
			font-family: Source Han Sans CN;
			color: #FFFEFE;
			animation-duration: 1s;
			display: flex;
			align-items: center;
			flex-direction: column;
			transition: all .5s ease;
			opacity: 0;
			transform: translateY(0);
			.swiper-slide-dw-name {
				font-size: 40px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #FFFFFF;
				text-align: center;
				width: 900px;
				transition: all .6s ease;
				opacity: 0;
				transform: translateY(0);
			}
		
			.swiper-slide-dw-cen {
				margin-top:10px;
				font-size: 18px;
				font-family: Source Han Sans CN;
				// font-weight: bold;
				color: #FFFFFF;
				margin-bottom: 20px;
				width: 900px;
				word-wrap: break-word;
				word-break: break-all;
				text-align: center;
				transition: all .6s ease .3s;
				opacity: 0;
				visibility: hidden;
				transform: translateY(0);
			}
		}
		//当前选中
		.xz{
			opacity: 1;
			transform: translateY(0);
			.swiper-slide-dw-name{
				opacity: 1;
				transform: translateY(0);
			}
			.swiper-slide-dw-cen{
				opacity: 1;
				visibility: visible;
				transform: translateY(0);
			}
		}
		// 小于当前
		.wxz{
			opacity: 0;
			// transform: translateY(-44px);
			.swiper-slide-dw-name{
				opacity: 0;
				transform: translateY(-44px);
			}
			.swiper-slide-dw-cen{
				opacity: 0;
				transform: translateY(-24px);
			}
		}
		// 大于当前
		.wxzTwo{
			opacity: 0;
			// transform: translateY(44px);
			.swiper-slide-dw-name{
				opacity: 0;
				transform: translateY(44px);
			}
			.swiper-slide-dw-cen{
				opacity: 0;
				transform: translateY(24px);
			}
		}
	}
	@media screen and (max-width:1200px) {
		.wxBoxTwo {
			max-width: 100vw !important;
			width: 100vw !important;
		}
		.swiper-slide-wz{
			width: calc(100vw - 60px) !important;
			left: 30px !important;
			.swiper-slide-dw-name{
				width: 100% !important;
				font-size: 24px !important;
			}
			.swiper-slide-dw-cen{
				font-size: 16px !important;
			}
		}
	}
</style>